import { Input } from '@/components/ui/input';

export interface PlanogramListingFeeInputProps {
  slotIds: string[];
  value: number;
  varies: boolean;
  disabled?: boolean;
  onChange: (slotIds: string[], raw: string) => void;
}

export function PlanogramListingFeeInput({
  slotIds,
  value,
  varies,
  disabled = false,
  onChange,
}: PlanogramListingFeeInputProps) {
  if (varies) {
    return (
      <span
        className="text-sm text-muted-foreground"
        title="Listing fees differ per slot — click a slot badge to edit each one"
      >
        Varies
      </span>
    );
  }

  if (disabled || slotIds.length === 0) {
    return <span className="text-sm text-muted-foreground">—</span>;
  }

  return (
    <Input
      type="number"
      min={0}
      step="0.01"
      className="ml-auto h-8 w-24 text-right text-sm tabular-nums"
      value={value > 0 ? value : ''}
      placeholder="0.00"
      aria-label="Listing fee (£)"
      onChange={(e) => onChange(slotIds, e.target.value)}
    />
  );
}
